import Joi from "joi-browser";

const actionNameField = {
  name: "actionName",
  label: "Name of the event",
  type: "text",
};

const phoneNumberField = {
  name: "phoneNumber",
  label: "To number",
  type: "text",
  description:
    "Leave it blank if you want to automatically pick the number from the call.",
};

const fromPhoneNumberField = {
  name: "fromNumber",
  label: "From Number",
  type: "select",
  options: [],
};

const triggerEventField = {
  name: "triggerEvent",
  label: "Trigger Event",
  type: "select",
  options: [
    { id: 1, value: "callStart", label: "Start of the call" },
    { id: 2, value: "duringCall", label: "During the call" },
    { id: 3, value: "callEnd", label: "End of the call" },
  ],
};

const triggerDescriptionField = {
  name: "trigger",
  label: "Describe when do you want to send the Whatsapp message",
  type: "textArea",
  style: { height: "150px" },
};

const messageTemplateField = {
  name: "template",
  label: "Message Template",
  description: "Select one of the pre-approved templates",
  type: "select",
  options: [
    { id: 0, value: JSON.stringify({}), label: "(No template selected)" },
  ],
};

const assistantField = {
  name: "assistant",
  label: "Whatsapp Assistant",
  type: "select",
  options: [{ id: 0, value: null, label: "Please select assistant" }],
};

const transferConversationMemoryField = {
  name: "transferConversationMemory",
  label: "Transfer Conversation Memory",
  type: "toggle",
};

const baseSchema = {
  actionName: Joi.string().required().max(50).label("Event name"),
  phoneNumber: Joi.string()
    .allow(null, "")
    .required()
    .max(300)
    .label("To number"),
  triggerEvent: Joi.string().required().label("Trigger Event"),
  template: Joi.object({
    templateName: Joi.string().required(),
    templateLanguage: Joi.string().required(),
  })
    .required()
    .label("Message Template"),
  transferConversationMemory: Joi.boolean(),
  assistant: Joi.string().allow(null, ""),
  fromNumber: Joi.string().allow(null, "").label("From Number"),
};

const commonSchema = {
  ...baseSchema,
  trigger: Joi.string().allow(null, "").label("Description"),
};

const descriptionFieldRequiredSchema = {
  ...baseSchema,
  trigger: Joi.string().required().max(1500).label("Description"),
};

const descriptionFieldTemplate = [
  {
    name: "actionName",
    label: "Name of the event",
    type: "text",
  },
  {
    name: "phoneNumber",
    label: "To number",
    type: "text",
    description:
      "Leave it blank if you want to automatically pick the number from the call.",
  },
  {
    name: "triggerEvent",
    label: "Trigger Event",
    type: "select",
    options: [
      { id: 1, value: "callStart", label: "Start of the call" },
      { id: 2, value: "duringCall", label: "During the call" },
      { id: 3, value: "callEnd", label: "End of the call" },
    ],
  },
  {
    name: "trigger",
    label: "Describe when do you want to send the SMS",
    type: "textArea",
    style: { height: "150px" },
  },
];

const commonFields = [];

export {
  commonSchema,
  descriptionFieldRequiredSchema,
  actionNameField,
  phoneNumberField,
  triggerEventField,
  triggerDescriptionField,
  messageTemplateField,
  assistantField,
  descriptionFieldTemplate,
  commonFields,
  transferConversationMemoryField,
  fromPhoneNumberField,
};
